export interface DamageDetailsForCodesResponse {
  disabledFields: string[];
  quantification1Text: string;
  quantification2Text: string;
  quantification1Unit: string;
  quantification2Unit: string;
}

export const emptyDamageDetailsForCodes: DamageDetailsForCodesResponse = {
  disabledFields: [],
  quantification1Text: "",
  quantification2Text: "",
  quantification1Unit: "",
  quantification2Unit: "",
};
